module.exports = __webpack_public_path__ + "img/location.71eba82d.svg";